const ENDPOINT = 'UPDATEdashboardprofile';
function updateDashboardProfile(gateway, params = {}) {
    return gateway.post(updateDashboardProfile.endpoint, params, params);
}
updateDashboardProfile.endpoint = ENDPOINT;

export { updateDashboardProfile as default };
//# sourceMappingURL=updateDashboardProfile.js.map
